var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85742 2.57143C4.85742 1.15127 6.00868 0 7.42885 0H16.8574C18.2775 0 19.4289 1.15127 19.4289 2.57143V17.1429C19.4289 18.563 18.2775 19.7143 16.8574 19.7143H7.42885C6.00868 19.7143 4.85742 18.563 4.85742 17.1429V2.57143Z",
    fill: "#65C3E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.571289 6.85756C0.571289 5.4374 1.72255 4.28613 3.14272 4.28613H12.5713C13.9915 4.28613 15.1427 5.4374 15.1427 6.85756V21.429C15.1427 22.8491 13.9915 24.0004 12.5713 24.0004H3.14272C1.72255 24.0004 0.571289 22.8491 0.571289 21.429V6.85756Z",
    fill: "#ABDEF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35691 8.57143C3.35691 7.97969 3.83662 7.5 4.42834 7.5H11.2855C11.8772 7.5 12.3569 7.97969 12.3569 8.57143C12.3569 9.16317 11.8772 9.64286 11.2855 9.64286H4.42834C3.83662 9.64286 3.35691 9.16317 3.35691 8.57143ZM3.35775 12.8571C3.35775 12.2654 3.83744 11.7857 4.42918 11.7857H11.2863C11.8781 11.7857 12.3577 12.2654 12.3577 12.8571C12.3577 13.4489 11.8781 13.9286 11.2863 13.9286H4.42918C3.83744 13.9286 3.35775 13.4489 3.35775 12.8571ZM4.42787 16.0714C3.83614 16.0714 3.35645 16.5511 3.35645 17.1429C3.35645 17.7346 3.83614 18.2143 4.42787 18.2143H7.85645C8.44818 18.2143 8.92787 17.7346 8.92787 17.1429C8.92787 16.5511 8.44818 16.0714 7.85645 16.0714H4.42787Z",
    fill: "#65C3E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiFileIcon);
export default __webpack_public_path__ + "static/media/multiFileIcon.a45e38cfb20009e5ebcdbe49f82ce64f.svg";
export { ForwardRef as ReactComponent };